// @angular
import { BrowserModule } from '@angular/platform-browser'
import { ErrorHandler, NgModule, Injector } from '@angular/core'
import { FormsModule }   from '@angular/forms'
import { HttpClientModule, HttpClient } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

// @ionic
import { IonicStorageModule } from '@ionic/storage'

// @ionic-native
import { SplashScreen } from '@ionic-native/splash-screen'
import { StatusBar } from '@ionic-native/status-bar'
import { GoogleAnalytics } from '@ionic-native/google-analytics'

// ionic-angular
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular'

// ngrx
import { StoreModule } from '@ngrx/store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'

// other libraries
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt'
import { ChartModule } from 'angular2-highcharts'
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService'
import { TranslateModule, TranslateLoader, TranslatePipe } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'

import * as highcharts from 'highcharts'
import * as heatmap from 'highcharts/modules/heatmap'

import { MyApp } from './app.component'
import { reducers } from '../reducers'

// apis
import { ApisModule } from '../apis'

// services
import { ServicesModule, AuthService } from '../services'

import { ENVIRONMENT } from '../config/environment'
import { AppErrorHandler } from './app-error-handler'
import { AppConfig } from '../config'

export function jwtOptionsFactory(injector) {
  return {
    tokenGetter: () => injector.get(AuthService).getToken(),
    whitelistedDomains: [
      'localhost:3000',
      'koyodai-api.getpa.net',
      'response-collector-demo.herokuapp.com',
      'response-collector-prod.herokuapp.com',
      'api.ws.rc.okumo.to',
      'kosen.ss.cs.tut.ac.jp',
      'kosen.ss.cs.tut.ac.jp:3000',
      AppConfig.apiServerHost,
    ]
  }
}

export function highchartsFactory() {
  heatmap(highcharts)

  return highcharts
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}


@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      mode: 'ios',
      preloadModules: true,
    }),
    IonicStorageModule.forRoot({
      name: 'Response_Collector'
    }),
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({ maxAge: 30 }),
    HttpClientModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Injector]
      }
    }),
    FormsModule,
    ApisModule,
    ServicesModule,
    ChartModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    GoogleAnalytics,
    {provide: ErrorHandler, useClass: ENVIRONMENT === 'development' ? IonicErrorHandler : AppErrorHandler},
    {
      provide: HighchartsStatic,
      useFactory: highchartsFactory
    },
  ],
  exports: [
    TranslatePipe,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts